module.exports = __webpack_public_path__ + "img/hr-branch-particle-26.06515448.png";